import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import PropTypes from "prop-types";
import { generatePath } from "react-router";
import { useParams } from "react-router-dom";
import {
  PARTICIPANT_HOME_PATH,
  PARTICIPANT_STRIPE_HOME_PATH,
} from "../../consts/participantHomePath";
import { useInIframe } from "../../hooks";
import { LinkKeepUTM } from "../LinkKeepUTM";
import { useStyles } from "./navigation.styles";

export const Navigation = ({ navigation }) => {
  const classes = useStyles();
  const params = useParams();
  const isInIframe = useInIframe();

  if (navigation.length === 0 || isInIframe) return null;

  const otherPaths = [...navigation];
  const deeperPath = otherPaths.pop();

  return (
    <Grid className={["noprint", classes.root].join(" ")} item xs={12}>
      <Breadcrumbs
        className={classes.hiddenBreadCrumb}
        separator="›"
        aria-label="breadcrumb"
      >
        {![PARTICIPANT_HOME_PATH, PARTICIPANT_STRIPE_HOME_PATH].includes(
          navigation[0]?.path
        ) && (
          <LinkKeepUTM
            className={[classes.link, "MuiTypography-colorPrimary"].join(" ")}
            to={PARTICIPANT_STRIPE_HOME_PATH}
          >
            Home
          </LinkKeepUTM>
        )}

        {otherPaths.map((navigationPath) => (
          <LinkKeepUTM
            key={`${navigationPath.title}`}
            className={[classes.link, "MuiTypography-colorPrimary"].join(" ")}
            to={generatePath(navigationPath.path, params)}
          >
            {navigationPath.title}
          </LinkKeepUTM>
        ))}
        <Typography className={clsx(classes.currentPage, classes.title)}>
          {deeperPath.title === "My Events" ? "Events" : deeperPath.title}
        </Typography>
      </Breadcrumbs>
      <hr className={classes.borderNewUser} />
    </Grid>
  );
};

Navigation.propTypes = {
  navigation: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ),
};

Navigation.defaultProps = {
  navigation: [],
};
